function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};

window.recentlyViewedIds = [];

/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.qty');
      this.step = this.input.getAttribute('step');
      this.changeEvent = new Event('change', {
        bubbles: true
      });
      // Create buttons
      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');

      // Add functionality to buttons
      this.subtract.addEventListener('click', () => this.change_quantity(-1 * this.step));
      this.add.addEventListener('click', () => this.change_quantity(1 * this.step));

    }
    connectedCallback() {
      this.classList.add('buttons_added');
    }
    change_quantity(change) {
      // Get current value
      let quantity = Number(this.input.value);

      // Ensure quantity is a valid number
      if (isNaN(quantity)) quantity = 1;

      // Check for min & max
      if (this.input.getAttribute('min') > (quantity + change)) {
        return;
      }
      if (this.input.getAttribute('max')) {
        if (this.input.getAttribute('max') < (quantity + change)) {
          return;
        }
      }
      // Change quantity
      quantity += change;

      // Ensure quantity is always a number
      quantity = Math.max(quantity, 1);

      // Output number
      this.input.value = quantity;

      this.input.dispatchEvent(this.changeEvent);
    }
  }
  customElements.define('quantity-selector', QuantityInput);
}



/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector('.product-card-swatches');
      this.image = this.querySelector('.product-featured-image-link .product-primary-image');
      this.secondary = this.querySelector('.product-featured-image-link .product-secondary-image');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
    }
    connectedCallback() {
      if (this.swatches) {
        this.enableSwatches();
      }
      if (this.quick_add) {
        this.enableQuickView();
      }
      if (this.secondary) {
        window.addEventListener('load', (event) => {
          lazySizes.loader.unveil(this.secondary);
        });
      }
    }
    enableSwatches() {
      let swatch_list = this.swatches.querySelectorAll('.product-card-swatch'),
        org_srcset = this.image ? this.image.dataset.srcset : '';


      swatch_list.forEach((swatch, index) => {
        window.addEventListener('load', (event) => {
          let image = new Image();
          image.srcset = swatch.dataset.srcset;
          lazySizes.loader.unveil(image);
        });
        swatch.addEventListener('mouseover', () => {

          [].forEach.call(swatch_list, function (el) {
            el.classList.remove('active');
          });
          if (this.image) {
            if (swatch.dataset.srcset) {
              this.image.setAttribute('srcset', swatch.dataset.srcset);
            } else {
              this.image.setAttribute('srcset', org_srcset);
            }
          }

          swatch.classList.add('active');
        });
        swatch.addEventListener('click', function (evt) {
          window.location.href = this.dataset.href;
          evt.preventDefault();
        });
      });
    }
    enableQuickView() {
      this.quick_add.addEventListener('click', this.quickAdd.bind(this));
    }

    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled) {
        return;
      }
      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      let formData = new FormData(this.form);

      formData.append('id', this.quick_add.dataset.productId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
        });

      return false;
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));


      if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').open();
      }

    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  }
  customElements.define('product-card', ProductCard);
}

/**
 *  @class
 *  @function PanelClose
 */
class PanelClose extends HTMLElement {

  constructor() {
    super();
    let cc = document.querySelector('.click-capture');

    // Add functionality to buttons
    this.addEventListener('click', (e) => this.close_panel(e));
    document.addEventListener('keyup', (e) => {
      if (e.code) {
        if (e.code.toUpperCase() === 'ESCAPE') {
          document.querySelectorAll('.side-panel').forEach((panel) => {
            panel.classList.remove('active');
            document.body.classList.remove('open-cc');
          });
        }
      }
    });
    cc.addEventListener('click', (e) => {
      document.body.classList.remove('open-cc');
      if (document.querySelector('.side-panel.active')) {
        document.querySelector('.side-panel.active').classList.remove('active');
      }
    });
  }

  close_panel(e) {
    e.preventDefault();
    let panel = e.target.closest('.side-panel');
    panel.classList.remove('active');
    document.body.classList.remove('open-cc');
  }
}
customElements.define('side-panel-close', PanelClose);

/**
 *  @class
 *  @function CartDrawer
 */
if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {

    constructor() {
      super();
    }
    connectedCallback() {
      let button = document.getElementById('cart-drawer-toggle');

      if (!button) {
        return;
      }
      // Add functionality to buttons
      button.addEventListener('click', (e) => {
        e.preventDefault();
        document.body.classList.add('open-cc');
        this.classList.add('active');
        this.focus();
        this.removeProductEvent();

        dispatchCustomEvent('cart-drawer:open');
      });

      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);

      document.addEventListener('cart:refresh', (event) => {
        this.refresh();
      });

      this.addEventListener('change', this.debouncedOnChange.bind(this));
      this.removeProductEvent();

      window.addEventListener('pageshow', () => {
        this.refresh();
      });
    }
    open() {
      document.body.classList.add('open-cc');
      this.classList.add('active');
      dispatchCustomEvent('cart-drawer:open');
      this.removeProductEvent();
    }
    close() {
      document.body.classList.remove('open-cc');
      this.classList.remove('active');
    }
    onChange(event) {
      if (event.target.classList.contains('qty')) {
        this.updateQuantity(event.target.dataset.index, event.target.value);
      }
      this.removeProductEvent();
    }
    removeProductEvent() {
      let removes = this.querySelectorAll('.remove');

      removes.forEach((remove) => {
        if (!remove.dataset.listenerAdded) {
          remove.addEventListener('click', (event) => {
            event.preventDefault();
            this.updateQuantity(event.currentTarget.dataset.index, '0');
          });
          remove.dataset.listenerAdded = "true";
        }
      });

      this.subscriptionEvent();
      this.selectEvent();
      this.addEvent();
      this.checkoutEvent();
      this.setupCarousel();
    }
    subscriptionEvent() {
      let subscriptions = this.querySelectorAll('.subscribe-button');

      subscriptions.forEach((subscription) => {
        if (!subscription.dataset.listenerAdded) {
          subscription.addEventListener('click', (event) => {
            event.preventDefault();

            this.subscribe(event.target.dataset.index, event.target.dataset.quantity, event.target.dataset.sellingPlan);
          })
          subscription.dataset.listenerAdded = "true";
        }
      })
    }
    selectEvent() {
      let selectors = this.querySelectorAll('.subscription-select');

      selectors.forEach((selector) => {
        if (!selector.dataset.listenerAdded) {
          selector.addEventListener('change', (event) => {
            event.preventDefault();

            this.subscribe(event.target.dataset.index, event.target.dataset.quantity, event.target.value);
          })
          selector.dataset.listenerAdded = "true";
        }
      })
    }
    addEvent() {
      let buttons = this.querySelectorAll('.cart-item-add');

      buttons.forEach((button) => {
        if (!button.dataset.listenerAdded) {
          button.addEventListener('click', (event) => {
            event.preventDefault();

            this.addItem(event.target.dataset.variant, event.target);
          })
          button.dataset.listenerAdded = "true";
        }
      })
    }
    checkoutEvent() {
      const form = this.querySelector('.cart-drawer-buttons form');
      if (!form) return;

      if (!form.dataset.listenerAdded) {
        form.addEventListener('submit', (event) => {
          event.preventDefault();

          const button = form.querySelector('.checkout-button');
          button.classList.add('loading');

          let offers = Number(sessionStorage.getItem('offers') ?? 0);
          let lastOffer = sessionStorage.getItem('last_offer');

          if (lastOffer) {
            lastOffer = new Date(lastOffer);
          } else {
            lastOffer = new Date();
            lastOffer.setDate(lastOffer.getDate() - 1);
            lastOffer.setHours(0, 1, 0, 0);
          }

          const todayStart = new Date();
          todayStart.setHours(0, 0, 0, 0);

          if (lastOffer < todayStart) {
            offers = 0;
          }

          offers++;
          sessionStorage.setItem('offers', offers);
          sessionStorage.setItem('last_offer', new Date().toISOString());

          if (offers <= 3) {
            let href = `/cart?view=product-offer`;

            fetch(href, {
              method: 'GET'
            })
              .then((response) => response.text())
              .then(text => {
                const sectionInnerHTML = new DOMParser()
                  .parseFromString(text, 'text/html')
                  .querySelector('#Product-Offer-Content').innerHTML;

                button.classList.remove('loading');

                if (sectionInnerHTML) {
                  this.showOfferPopup(sectionInnerHTML);
                } else {
                  this.resumeCheckout()
                }
              })
              .catch(err => {
                console.error('Offer fetch failed, continuing to checkout', err);
                this.resumeCheckout();
              });
          } else {
            this.resumeCheckout();
          }
        })
        form.dataset.listenerAdded = "true";
      }
    }
    resumeCheckout() {
      window.location.href = '/checkout';
    }
    showOfferPopup(htmlContent) {
      const wrapper = document.createElement('div');
      wrapper.classList.add('offer-popup-wrapper');

      const overlay = document.createElement('div');
      overlay.style.cssText = `
        position: absolute;
        inset: 0;
        background: rgba(196, 196, 196, 0.7);
        backdrop-filter: blur(3px);
      `;
      wrapper.appendChild(overlay);

      const popup = document.createElement('div');
      popup.classList.add('offer-popup');
      popup.innerHTML = htmlContent;

      wrapper.appendChild(popup);
      document.body.appendChild(wrapper);

      overlay.addEventListener('click', () => {
        cleanup();
        this.resumeCheckout();
      });

      const closeBtn = popup.querySelector('.popup-offer-close');
      if (closeBtn) {
        closeBtn.addEventListener('click', () => {
          cleanup();
          this.resumeCheckout();
        });
      }

      const checkoutBtn = popup.querySelector('.checkout-button');
      if (checkoutBtn) {
        checkoutBtn.addEventListener('click', (event) => {
          event.preventDefault();

          cleanup();
          this.resumeCheckout();
        });
      }

      const variantSelector = popup.querySelector('.offer-product-select');
      const variantImage = popup.querySelector('.offer-product-image img');
      const variantAdd = popup.querySelector('.cart-item-add');
      const variantPrice = popup.querySelector('.price');
      if (variantSelector) {
        let org_srcset = variantImage ? variantImage.dataset.srcset : '';

        window.addEventListener('load', () => {
          const loadedImages = new Set();

          [...variantSelector.options].forEach(option => {
            const srcset = option.dataset.srcset;

            if (srcset && !loadedImages.has(srcset)) {
              loadedImages.add(srcset);

              const image = new Image();
              image.srcset = srcset;
              lazySizes.loader.unveil(image);
            }
          });
        });

        variantSelector.addEventListener('change', (event) => {
          const selectedOption = event.target.selectedOptions[0];

          if (!selectedOption) return;

          if (variantImage) {
            if (selectedOption.dataset.srcset) {
              variantImage.setAttribute('srcset', selectedOption.dataset.srcset);
            } else {
              variantImage.setAttribute('srcset', org_srcset);
            }
          }
          if (variantAdd && selectedOption.value) {
            variantAdd.dataset.variant = selectedOption.value;
            const url = new URL(variantAdd.href, window.location.origin);
            url.searchParams.set('id', selectedOption.value);
            variantAdd.href = url.toString();
          }
          if (variantPrice && (selectedOption.dataset.price || selectedOption.dataset.rrp)) {
            const option_price = selectedOption.dataset.price ? selectedOption.dataset.price / 100 : null;
            const option_rrp = selectedOption.dataset.rrp ? selectedOption.dataset.rrp / 100 : null;

            if (option_price && option_rrp && option_rrp > option_price) {
              const savedAmount = Math.round(((option_rrp - option_price) / option_rrp) * 100);

              variantPrice.innerHTML = `
                <del><span class="amount">${option_rrp.toLocaleString(undefined, { style: 'currency', currency: 'AUD', currencyDisplay: 'narrowSymbol' })}</span></del>
                <ins><span class="amount discounted">${option_price.toLocaleString(undefined, { style: 'currency', currency: 'AUD', currencyDisplay: 'narrowSymbol' })}</span></ins>
                <span class="badges"><span class="badge onsale">Save ${savedAmount}%</span></span>
              `
            } else {
              variantPrice.innerHTML = `
                <ins><span class="amount discounted">${option_price.toLocaleString(undefined, { style: 'currency', currency: 'AUD', currencyDisplay: 'narrowSymbol' })}</span></ins>
              `
            }
          }
        })
      }

      if (variantAdd) {
        variantAdd.addEventListener('click', (event) => {
          event.preventDefault();

          if (event.target.closest('.offer-product-image')) {
            event.target.closest('.offer-product-image').classList.add('loading');
          }
          const body = JSON.stringify({
            id: event.target.dataset.variant,
            quantity: 1,
            properties: { '_source': 'artisti', '_attribution': 'pre-purchase' },
            sections_url: window.location.pathname
          });
          fetch(`${theme.routes.cart_add_url}`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': `application/json`
            },
            ...{
              body
            }
          })
            .then((response) => {
              return response.text();
            })
            .then((state) => {
              cleanup();
              this.resumeCheckout();
            });
        })
      }

      requestAnimationFrame(() => {
        wrapper.classList.add('visible');

        const chat = document.getElementById('ShopifyChat');
        if (chat) {
          chat.style.zIndex = 90000;
        }
      });

      let timerId;
      const timerMinutes = popup.querySelector('.offer-timer-minutes');
      const timerSeconds = popup.querySelector('.offer-timer-seconds');
      const endTime = Date.now() + 3 * 60 * 1000;

      const updateTimer = () => {
        const remaining = Math.max(0, endTime - Date.now());
        const mins = String(Math.floor(remaining / 60000));
        const secs = String(Math.floor((remaining % 60000) / 1000)).padStart(2, '0');
        if (timerMinutes) timerMinutes.textContent = `${mins}`;
        if (timerSeconds) timerSeconds.textContent = `${secs}`;

        if (remaining <= 0) {
          cleanup();
          this.resumeCheckout();
        }
      }

      timerId = setInterval(updateTimer, 400);
      updateTimer();

      function cleanup() {
        clearInterval(timerId);

        wrapper.classList.add('loading');

        setTimeout(() => {
          wrapper.remove();
        }, 200);
      }
    }
    setupCarousel() {
      const carousel = this.querySelector('.product-recommendations-drawer__products');
      if (carousel) {
        const items = carousel.children;
        const btnLeft = this.querySelector('.carousel-button.left');
        const btnRight = this.querySelector('.carousel-button.right');
        let itemWidth = items[0].offsetWidth + 16;

        const updateButtons = () => {
          if (btnLeft) btnLeft.disabled = carousel.scrollLeft <= 0;
          if (btnRight) btnRight.disabled = carousel.scrollLeft >= carousel.scrollWidth - carousel.clientWidth;
        };

        const scrollCarousel = (direction) => {
          carousel.scrollBy({ left: direction * itemWidth, behavior: 'smooth' });
          setTimeout(updateButtons, 300);
        };

        if (btnLeft) btnLeft.addEventListener('click', () => scrollCarousel(-1));
        if (btnRight) btnRight.addEventListener('click', () => scrollCarousel(1));

        // Mouse drag
        let isDown = false, startX, scrollLeftValue;
        carousel.addEventListener('mousedown', e => {
          isDown = true; startX = e.pageX - carousel.offsetLeft; scrollLeftValue = carousel.scrollLeft;
        });
        carousel.addEventListener('mouseleave', () => isDown = false);
        carousel.addEventListener('mouseup', () => isDown = false);
        carousel.addEventListener('mousemove', e => {
          if (!isDown) return;
          e.preventDefault();
          const x = e.pageX - carousel.offsetLeft;
          carousel.scrollLeft = scrollLeftValue + (startX - x);
        });

        // Touch
        carousel.addEventListener('touchstart', e => startX = e.touches[0].pageX);
        carousel.addEventListener('touchmove', e => {
          const x = e.touches[0].pageX;
          carousel.scrollLeft += (startX - x);
          startX = x;
        });

        // Snap on scroll end
        carousel.addEventListener('scroll', () => {
          clearTimeout(carousel.snapTimeout);
          carousel.snapTimeout = setTimeout(() => {
            const nearestIndex = Math.round(carousel.scrollLeft / itemWidth);
            carousel.scrollTo({ left: nearestIndex * itemWidth, behavior: 'smooth' });
            updateButtons();
          }, 100);
        });

        updateButtons();
      }
    }
    getSectionsToRender() {
      return [{
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    updateQuantity(line, quantity) {
      this.querySelector(`#CartDrawerItem-${line}`).classList.add('thb-loading');
      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });
      dispatchCustomEvent('line-item:change:start', {
        quantity: quantity
      });
      fetch(`${theme.routes.cart_change_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        ...{
          body
        }
      })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);


          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

          }));

          this.removeProductEvent();

          dispatchCustomEvent('line-item:change:end', {
            quantity: quantity,
            cart: parsedState
          });
          if (this.querySelector(`#CartDrawerItem-${line}`)) {
            this.querySelector(`#CartDrawerItem-${line}`).classList.remove('thb-loading');
          }
        });
    }
    subscribe(line, quantity, selling_plan) {
      this.querySelector(`#CartDrawerItem-${line}`).classList.add('thb-loading');
      const body = JSON.stringify({
        line,
        quantity,
        selling_plan,
        properties: { '_source': 'artisti', '_attribution': 'switch to subscription' },
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });
      dispatchCustomEvent('line-item:change:start', {
        selling_plan: selling_plan
      });
      fetch(`${theme.routes.cart_change_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        ...{
          body
        }
      })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);


          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

          }));

          this.removeProductEvent();

          dispatchCustomEvent('line-item:change:end', {
            selling_plan: selling_plan,
            cart: parsedState
          });
          if (this.querySelector(`#CartDrawerItem-${line}`)) {
            this.querySelector(`#CartDrawerItem-${line}`).classList.remove('thb-loading');
          }
        });
    }
    addItem(variant, button) {
      button.closest('.product-cart-item').classList.add('thb-loading');
      const body = JSON.stringify({
        id: variant,
        quantity: 1,
        properties: { '_source': 'artisti', '_attribution': 'cart product recommendations' },
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });
      dispatchCustomEvent('line-item:add:start', {
        item: variant
      });
      fetch(`${theme.routes.cart_add_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        ...{
          body
        }
      })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);


          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

          }));

          this.removeProductEvent();

          dispatchCustomEvent('line-item:add:end', {
            item: variant,
            cart: parsedState
          });
          if (button.closest('.product-cart-item')) {
            button.closest('.product-cart-item').classList.remove('thb-loading');
          }
        });
    }
    refresh() {
      let sections = 'cart-drawer,cart-bubble';
      fetch(`${window.location.pathname}?sections=${sections}`)
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
          }));

          this.removeProductEvent();
        });
    }
  }
  customElements.define('cart-drawer', CartDrawer);
}

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.cc = document.querySelector('.click-capture');
      this.drawer = document.getElementById('Product-Drawer');
      this.body = document.body;

      this.addEventListener('click', this.setupEventListener.bind(this));
      this.cc.addEventListener('click', this.setupCCEventListener.bind(this));

    }
    setupCCEventListener(e) {
      this.body.classList.remove('open-cc');
      this.drawer.classList.remove('active');
      this.drawer.querySelector('#Product-Drawer-Content').innerHTML = '';
    }
    setupEventListener(e) {
      e.preventDefault();
      let productHandle = this.dataset.productHandle,
        href = `/products/${productHandle}?view=quick-view`;

      if (!productHandle) {
        return;
      }
      if (this.classList.contains('loading')) {
        return;
      }
      this.classList.add('loading');
      fetch(href, {
        method: 'GET'
      })
        .then((response) => {
          this.classList.remove('loading');
          return response.text();
        })
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#Product-Drawer-Content').innerHTML;

          this.renderQuickview(sectionInnerHTML, href, productHandle);

        });
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {

        this.drawer.querySelector('#Product-Drawer-Content').innerHTML = sectionInnerHTML;

        let js_files = this.drawer.querySelector('#Product-Drawer-Content').querySelectorAll('script');

        if (js_files.length > 0) {
          var head = document.getElementsByTagName('head')[0];
          js_files.forEach((js_file, i) => {
            let script = document.createElement('script');
            script.src = js_file.src;
            head.appendChild(script);
          });
        }

        setTimeout(() => {
          window.dispatchEvent(new Event('resize'));
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);



        this.body.classList.add('open-cc');
        this.drawer.classList.add('active');
        this.drawer.querySelector('.side-panel-close').focus();

        dispatchCustomEvent('quick-view:open', {
          productUrl: href,
          productHandle: productHandle
        });
      }
    }
  }
  customElements.define('quick-view', QuickView);
}

/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

  }
  fetchProducts() {
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const recommendations = this.extractProductRecommendations(text);

        if (recommendations) {
          this.innerHTML = recommendations;
        }
        this.classList.add('product-recommendations--loaded');

        window.dispatchEvent(new Event('resize'));
      })
      .catch(e => {
        console.error(e);
      });
  }
  extractProductRecommendations(htmlText) {
    const tagName = 'product-recommendations';

    const openingTagRegex = new RegExp(`<${tagName}[^>]*>`, 'i');
    const closingTag = `</${tagName}>`;

    const openTagMatch = htmlText.match(openingTagRegex);
    if (!openTagMatch) return null;

    const openTagStart = htmlText.indexOf(openTagMatch[0]);
    const openTagEnd = htmlText.indexOf('>', openTagStart);
    if (openTagEnd === -1) return null;

    const closeTagIndex = htmlText.indexOf(closingTag, openTagEnd);
    if (closeTagIndex === -1) return null;

    return htmlText.slice(openTagEnd + 1, closeTagIndex).trim();
  }
  connectedCallback() {
    this.fetchProducts();
  }
}

customElements.define('product-recommendations', ProductRecommendations);

/**
 *  @class
 *  @function SelectWidth
 */
class SelectWidth {
  constructor() {
    let _this = this;
    // resize on initial load
    document.querySelectorAll(".resize-select").forEach(_this.resizeSelect);

    // delegated listener on change
    document.body.addEventListener("change", (e) => {
      if (e.target.matches(".resize-select") && e.target.offsetParent !== null) {
        _this.resizeSelect(e.target);
      }
    });
    window.addEventListener('resize.resize-select', function () {
      document.querySelectorAll(".resize-select").forEach(_this.resizeSelect);
    });
  }

  resizeSelect(sel) {
    let tempOption = document.createElement('option');
    tempOption.textContent = sel.selectedOptions[0].textContent;

    let tempSelect = document.createElement('select');
    tempSelect.style.visibility = "hidden";
    tempSelect.style.position = "fixed";
    tempSelect.appendChild(tempOption);

    sel.after(tempSelect);
    if (tempSelect.clientWidth > 0) {
      sel.style.width = `${+tempSelect.clientWidth + 12}px`;
    }
    tempSelect.remove();
  }
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  // https://css-tricks.com/how-to-animate-the-details-element/
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');

      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      this.querySelector('summary').addEventListener('click', (e) => this.onClick(e));
    }
    prepareAnimations() {
      let _this = this,
        summary_height = this.querySelector('summary').offsetHeight,
        content_height = this.querySelector('.collapsible__content').offsetHeight,
        initial_height = summary_height,
        final_height = summary_height + content_height;

      this.tl = false;
      this.tl = gsap.timeline({
        reversed: !_this.details.open,
        paused: true,
        inherit: false,
        ease: 'none',
        onStart: function () {
          _this.details.open = true;
          _this.details.style.overflow = 'hidden';
        },
        onReverseComplete: function () {
          _this.details.open = false;
          _this.details.style.overflow = '';
        }
      });

      this.tl
        .fromTo(_this.details, {
          height: function () {
            let h = Math.max(Math.max(initial_height, 0), 24);
            return h;
          },
          clearProps: 'height'
        }, {
          duration: 0.4,
          height: final_height,
          clearProps: 'height'
        });

      if (this.details.open) {
        this.tl.progress(1);
      }
    }
    instantClose() {
      this.tl.timeScale(10).reverse();
    }
    animateClose() {
      this.tl.timeScale(3).reverse();
    }
    animateOpen() {
      this.tl.timeScale(1).play();
    }
    onClick(e) {
      // Stop default behaviour from the browser
      e.preventDefault();
      // Add an overflow on the <details> to avoid content overflowing
      this.details.style.overflow = 'hidden';
      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.details.open) {
        this.open();
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }
    shrink() {
      // Set the element as "being closed"
      this.isClosing = true;

      // Store the current height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease'
      });

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      // Apply a fixed height on the element
      this.details.style.height = `${this.details.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.details.open = true;
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = '';
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}

/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {

  if (!handle) {
    let product = document.querySelector('.thb-product-detail');

    if (product) {
      handle = product.dataset.handle;
    }
  }
  if (!handle) {
    return;
  }
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem('recently-viewed');
    if (recentIds != 'undefined' && recentIds != null) {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }
  // Remove current product if already in recently viewed array
  var i = window.recentlyViewedIds.indexOf(handle);

  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }

  // Add id to array
  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem('recently-viewed', JSON.stringify(window.recentlyViewedIds));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (typeof SelectWidth !== 'undefined') {
    new SelectWidth();
  }
  if (typeof CartDrawer !== 'undefined') {
    new CartDrawer();
  }

});